    (function (global, factory) {
      "use strict";

      factory();
    })(this, function () {
      "use strict";

      // 注册组件键名
      var EL_KEY = "cus-modal-content";
      if (!customElements.get(EL_KEY)) {
        customElements.define(
          EL_KEY,
          class cusElement extends HTMLElement {
            static observedAttributes = ["mode", "title", "content"];

            constructor() {
              super();

              // shadow DOM 设置'closed'，即不可以从外部获取 Shadow DOM
              // 注意，创建了该元素，就不可以在该组件内嵌任何HTML片段，会无效
              this.shadow = this.attachShadow({ mode: "open" });
              this.init();
            }

            init(options = {}) {
              this.initGlobal();

              this.renderUI();
              this.activateEvent();
              this.resizeEvent();
            }

            initGlobal(options = {}) {
              this.mode = this.getAttribute("mode");

              this.gym = this.mode == "gym" ? "aux-gym" : "";

              console.log("this.mode: ", this.mode);
            }

            /**
             * 渲染样式
             */
            renderStyle() {
              var style = document.createElement("style");
              style.textContent = `
                .com-layout,
                .com-layout *:not(.filter-box) {
                  -webkit-box-sizing: border-box;
                  box-sizing: border-box;
                  font-family: Montserrat;
                  letter-spacing: 0;
                }
                .com-frame {
                  overflow: hidden;
                  width: 100%;
                  height: 100%;
                }
                .com-flex {
                  display: -webkit-flex;
                  display: flex;
                }
                .com-flex-center {
                  display: -webkit-flex;
                  display: flex;
                  justify-content: center;
                  -webkit-justify-content: center;
                  -moz-justify-content: center;
                  align-items: center;
                  -webkit-align-items: center;
                }
                .com-fedfitness-modal-content {
                  visibility: hidden;
                  overflow: hidden;
                  z-index: 999;
                  position: fixed;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                }
                .com-fedfitness-modal-content[data-open="true"] {
                  visibility: visible;
                }
                .com-fedfitness-modal-content .mask {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background-color: rgb(0, 0, 0, 0);

                  transition-duration: 300ms;
                  -webkit-transition-duration: 300ms;
                  -moz-transition-duration: 300ms;
                  -o-transition-duration: 300ms;
                }
                .com-fedfitness-modal-content[data-open="true"] .mask {
                  background-color: rgb(0, 0, 0, 0.3);

                  transition-duration: 300ms;
                  -webkit-transition-duration: 300ms;
                  -moz-transition-duration: 300ms;
                  -o-transition-duration: 300ms;
                }





                .com-fedfitness-modal-content .layout-content {
                  overflow: hidden;
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  padding: 48px 24px;
                }
                .com-fedfitness-modal-content .wrapper-content {
                  overflow: hidden;
                  position: relative;
                  padding-top: 60px;
                  width: 100%;
                  max-height: 100%;
                  border-radius: 12px;
                  background-color: #fff;

                  transform: translate3d(0, -100px, 0);

                  transition-duration: 300ms;
                  -webkit-transition-duration: 300ms;
                  -moz-transition-duration: 300ms;
                  -o-transition-duration: 300ms;
                }
                .com-fedfitness-modal-content[data-open="true"] .wrapper-content {
                  transform: translate3d(0, 0, 0);

                  transition-duration: 300ms;
                  -webkit-transition-duration: 300ms;
                  -moz-transition-duration: 300ms;
                  -o-transition-duration: 300ms;
                }
                .com-fedfitness-modal-content .wrapper-header {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 60px;
                }
                .com-fedfitness-modal-content .wrapper-header .icon-close {
                  position: absolute;
                  top: 6px;
                  right: 6px;
                  width: 32px;
                  height: 32px;
                  cursor: pointer;
                }
                .com-fedfitness-modal-content .wrapper-header .icon-close::before,
                .com-fedfitness-modal-content .wrapper-header .icon-close::after {
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 16px;
                  height: 1px;
                  background: #000;

                  transform: translate(-50%, -50%) rotate(45deg);
                  -ms-transform: translate(-50%, -50%) rotate(45deg);
                  -webkit-transform: translate(-50%, -50%) rotate(45deg);
                  -moz-transform: translate(-50%, -50%) rotate(45deg);
                }
                .com-fedfitness-modal-content .wrapper-header .icon-close::after {
                  transform: translate(-50%, -50%) rotate(-45deg);
                  -ms-transform: translate(-50%, -50%) rotate(-45deg);
                  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
                  -moz-transform: translate(-50%, -50%) rotate(-45deg);
                }
                  
                .com-fedfitness-modal-content .warpper-body {
                  overflow-x: hidden;
                  overflow-y: auto;
                  -webkit-overflow-scrolling: touch;

                  position: relative;
                  max-height: calc(100vh - 48px * 2 - 60px);
                }
                .com-fedfitness-modal-content .warpper-body-scroll {
                  position: relative;
                  padding-right: 16px;
                  padding-left: 16px;
                }


                @media only screen and (min-width: 1025px) {
                  .com-fedfitness-modal-content .layout-content {
                    padding: 125px 25px;
                  }
                  .com-fedfitness-modal-content .wrapper-content {
                    padding: 112px 0 0 0;
                    border-radius: 28px;
                  }
                  .com-fedfitness-modal-content .wrapper-header {
                    height: 112px;
                  }
                  .com-fedfitness-modal-content .wrapper-header .icon-close {
                    top: 12px;
                    right: 12px;
                    width: 48px;
                    height: 48px;
                  }
                  .com-fedfitness-modal-content .wrapper-header .icon-close::before,
                  .com-fedfitness-modal-content .wrapper-header .icon-close::after {
                    width: 20px;
                  }
                  .com-fedfitness-modal-content .warpper-body {
                    max-height: calc(100vh - 125px * 2 - 112px);
                  }
                }

                @media only screen and (min-width: 1350px) {
                  .com-fedfitness-modal-content .wrapper-content {
                    max-width: 1260px;
                  }
                }

                @media only screen and (min-width: 1350px) {
                  .com-fedfitness-modal-content .layout-content {
                    padding: 125px 185px;
                  }
                }


                @media only screen and (min-width: 1680px) {
                  .com-fedfitness-modal-content .layout-content {
                    padding: 125px 285px;
                  }    
                }




                .com-fedfitness-modal-content.aux-gym .layout-content {
                  align-items: end;
                  -webkit-align-items: end;

                  padding-bottom: 0;
                }
                .com-fedfitness-modal-content.aux-gym .wrapper-content {
                  border-bottom-right-radius: 0;
                  border-bottom-left-radius: 0;
                }
                .com-fedfitness-modal-content.aux-gym .warpper-body { 
                  max-height: calc(100vh - 48px - 60px);
                }
                .com-fedfitness-modal-content .warpper-body-scroll {
                  padding-bottom: 16px;
                }

                @media only screen and (min-width: 1025px) {
                  .com-fedfitness-modal-content.aux-gym .layout-content {
                    align-items: center;
                    -webkit-align-items: center;

                    padding-bottom: 125px;
                  }
                  .com-fedfitness-modal-content.aux-gym .wrapper-content {
                    border-bottom-right-radius: 28px;
                    border-bottom-left-radius: 28px;
                  }
                  .com-fedfitness-modal-content.aux-gym .warpper-body {
                    max-height: calc(100vh - 125px * 2 - 112px);
                  }
                  .com-fedfitness-modal-content .warpper-body-scroll {
                    padding-right: 62px;
                    padding-left: 62px;
                    padding-bottom: 62px;
                  }
                }


              `;

              this.shadow.appendChild(style);
            }

            /**
             * 渲染UI
             */
            renderUI() {
              // 将模板插入Shadow DOM
              var templateHTML = `
                <div class="com-layout com-fedfitness-modal-content ${this.gym}">
                  <div class="mask"></div>
                  <div class="com-flex-center layout-content">
                    <div class="wrapper-content">
                      <div class="wrapper-header">
                        <div class="icon-close"></div>
                      </div>
                      <div class="warpper-body">
                        <div class="warpper-body-scroll"><slot></slot></div>
                      </div>
                    </div>
                  </div>
                </div>
              `;

              this.shadow.innerHTML = templateHTML;
              this.renderStyle();
            }

            /**
             * 激活事件
             */
            activateEvent() {
              this.closeEvent();
            }

            closeEvent() {
              var closeEl = this.shadow.querySelector(".icon-close");
              var _this = this;
              closeEl.addEventListener(
                "click",
                function () {
                  _this.close();
                },
                false,
              );
            }

            open() {
              const modalEl = this.shadow.querySelector(
                ".com-fedfitness-modal-content",
              );
              modalEl.setAttribute("data-open", "true");
              document.body.setAttribute("data-overflow", "true");
            }

            close() {
              const modalEl = this.shadow.querySelector(
                ".com-fedfitness-modal-content",
              );
              modalEl.removeAttribute("data-open");
              document.body.removeAttribute("data-overflow");
            }

            /**
             * 窗口尺寸变化
             */
            resizeEvent() {
              const _this = this;

              window.onresize = function () {
                _this.renderUI();
                _this.activateEvent();
              };
            }
          },
        );
      }
    });